import React from "react";
import { Link } from "react-router-dom";
import { Calendar, Clock, ArrowRight } from "lucide-react";

/**
 * RelatedPosts — "Keep reading" grid of cards shown at the end of a blog post.
 * Props:
 *   - items: array of post objects (title, slug, date, read_minutes, tags, excerpt)
 */
export default function RelatedPosts({ items = [] }) {
  if (!items.length) return null;

  return (
    <section data-testid="related-posts" className="mt-16">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <div className="eyebrow text-orange" style={{ fontSize: 10 }}>KEEP READING</div>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-navy mt-2">
            More field notes from the team.
          </h2>
        </div>
        <Link
          to="/blog"
          className="text-sm font-semibold text-navy/60 hover:text-[#FF6B35] whitespace-nowrap inline-flex items-center gap-1"
          data-testid="related-posts-all"
        >
          All posts <ArrowRight size={13} />
        </Link>
      </div>

      <div className={`grid gap-4 ${items.length >= 3 ? "md:grid-cols-3" : "md:grid-cols-2"}`}>
        {items.map((p) => (
          <Link
            key={p.slug}
            to={`/blog/${p.slug}`}
            data-testid={`related-post-${p.slug}`}
            className="group rounded-2xl bg-white border border-[rgba(10,14,26,0.08)] p-5 hover:border-[#FF6B35] transition lift"
          >
            <div className="flex items-center gap-2 flex-wrap mb-3">
              {p.tags.slice(0, 2).map((t) => (
                <span key={t} className="chip chip-navy text-[10px]">{t}</span>
              ))}
            </div>
            <div className="font-display font-bold text-navy text-base leading-snug group-hover:text-[#FF6B35] transition">
              {p.title}
            </div>
            <p className="ink text-[13px] mt-2 leading-relaxed line-clamp-3">
              {p.excerpt}
            </p>
            <div className="mt-4 flex items-center gap-3 text-[11px] ink">
              <span className="inline-flex items-center gap-1"><Calendar size={11} /> {new Date(p.date).toLocaleDateString(undefined, { month: "short", day: "numeric" })}</span>
              <span className="inline-flex items-center gap-1"><Clock size={11} /> {p.read_minutes} min</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
